import request from "@/utils/request";

// 创建组织机构
export const  createOrg =(data) =>{
    return request({
        url: "/businessservice/org/create",
        method:"post",
        data: data
    })
}

// 编辑组织机构
export const  updateOrg =(data) =>{
    return request({
        url: "/businessservice/org/update",
        method:"post",
        data: data
    })
}

// 分页查询组织机构
export const  pageOrg =(data) =>{
    return request({
        url: "/businessservice/org/page",
        method:"post",
        data: data
    })
}


// 激活组织机构
export const  activeOrg =(data) =>{
    return request({
        url: "/businessservice/org/active",
        method:"post",
        data: data
    })
}

// 查询用户管理的组织机构
export const  queryUserManagerOrg =(query) =>{
    return request({
        url: "/businessservice/org/listUserManagerOrg",
        method:"get",
        params: query
    })
}
 
// 查询用户管理的组织机构
export const  queryManagerOrgAndUser =(query) =>{
    return request({
        url: "/businessservice/org/listManagerOrgAndUser",
        method:"get",
        params: query
    })
}